import { getApiVersion, http } from '../utils/domain'

// 获取统计数据
export const fetchStatisticsData = (appId, tbId, filters = {}) => {
  return http()
    .post(`${getApiVersion()}/apps/${appId}/mapInit/tbs/${tbId}/getLegendNum`, {
      ...filters,
    })
    .json()
    .then((res) => {
      return res
    })
}

export const fetchAmapSearch = (key, keywords) => {
  return http()
    .get(
      `https://restapi.amap.com/v3/place/text?key=${key}&keywords=${keywords}`
    )
    .json()
}
